import stringify from 'json-stable-stringify'

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export function stableStringify(obj: any) {
  return stringify(obj, { space: 2 })
}
